






























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { userApi } from '../user.api';
import { User } from '../user';
import UserEdit from './UserEdit.vue';
import { RoleType } from '@shared/common/types';
import { UserFormModel } from '../user.form-model';

@Component({
  components: {
    UserEdit,
  },
})
export default class UserSelect extends Vue {
  public users: User[] = [];
  public selectedUser: User | null = null;
  public personAutocompleteText = '';
  public showUserCreationForm = false;
  public newUser = new UserFormModel();

  @Prop()
  public value: any;

  @Prop({
    default: true,
  })
  public modelAsId!: boolean;

  @Prop({
    default: false,
  })
  public required!: boolean;

  @Prop()
  public label!: string;

  @Prop()
  public role!: RoleType;

  @Prop()
  public selectType!: string;

  public get fieldLabel(): string {
    return this.label || 'Utilisateur';
  }

  public get result(): string | null | User {
    if (!this.selectedUser) {
      return null;
    }

    return this.modelAsId ? this.selectedUser.id : this.selectedUser;
  }

  public async getUsers(label?: string): Promise<User[]> {
    try {
      const queryObject = { query: label, roles: [this.role] };

      if (this.role)  {
        queryObject.roles = [this.role];
      }

      this.users = await userApi.findAll(queryObject);
      return this.users;
    } catch (_) {
      console.error('e', _);
      return [];
    }
  }

  public createNewUser(): void {
    this.showUserCreationForm = true;
    this.$emit('newUser', this.newUser);
  }

  public async mounted(): Promise<void> {
    await this.getUsers();
    this.setModelFromValue();
  }

  @Watch('users')
  public onUsersChange(): void {
    if (!this.selectedUser && this.inputTextIsListed()) {
      this.selectedUser = this.findUserMatchingSearch() || null;
      this.$emit('input', this.result);
    }
  }

  @Watch('value')
  public setModelFromValue(): void {
    if (this.users.length === 0) {
      return;
    }
    // if (!this.value && this.users.length === 1) {
    //   this.selectedUser = this.users[0];
    //   this.personAutocompleteText = this.selectedUser.label;
    //   this.$emit('input', this.result);
    //   return;
    // }

    if (this.modelAsId && this.value) {
      this.selectedUser =
        this.users.find((user) => user.id === this.value) || null;
      if (this.selectedUser) {
        this.personAutocompleteText = this.selectedUser.fullname;
        this.$emit('input', this.result);
      }
    } else if (!this.modelAsId && this.value) {
      this.selectedUser =
        this.users.find((user) => user.id === this.value.id) || null;
      if (this.selectedUser) {
        this.personAutocompleteText = this.selectedUser.fullname;
        this.$emit('input', this.result);
      }
    }
  }

  public onUserSelected(user: any): void {
    this.selectedUser = user;
    this.$emit('input', this.result);
  }

  public resetSelected(): void {
    this.selectedUser = null;
    this.$emit('input', this.result);
  }

  public onInputChange(): void {
    if (
      this.selectedUser &&
      this.personAutocompleteText !== this.selectedUser.fullname
    ) {
      this.selectedUser = null;
      this.$emit('input', this.result);
    } else if (!this.selectedUser && this.inputTextIsListed()) {
      this.selectedUser = this.findUserMatchingSearch() || null;
      this.$emit('input', this.result);
    }

    this.getUsers(this.personAutocompleteText);
  }

  public inputTextIsListed(): boolean {
    return !!this.findUserMatchingSearch();
  }

  public findUserMatchingSearch(): User | undefined {
    return this.users.find(
      (user) => user.fullname === this.personAutocompleteText,
    );
  }

    public onCancel(): void {
    this.showUserCreationForm = false;
    this.$emit('cancel');
  }

  @Watch('role', { immediate: true })
  public onRolechange(role?: RoleType): void {
    if (role) {
      this.newUser.role = role;
    }
  }
}
